import React from 'react';
import { IconFill, IconProps } from './IconTemplate';

import { ReactComponent as Icon } from '@assets/icons/close.svg';

export default function CloseIcon(props: IconProps) {
  return <IconFill icon={Icon} {...props} />;
}
